//pullstate store

import { Store } from 'pullstate';

export const UserStore = new Store({
    users: [],
});
